import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';

import {
	setModoTela, initForm
} from './incubacaoPlanejamentoActions';
import {
	setModoTela as setModoTelaIncubacao
} from '../incubacao/incubacaoActions';
import consts from '../consts';
import ClipboardImageHandler from '../common/form/ClipboardImageHandler';
import TextoInput from '../texto/textoInput';

class IncubacaoPlanejamentoForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir || this.props.visualizacao ? 'readOnly' : '';

		
		return (
			<Row alignCenter>
				<Grid cols='12 10 8 5'
					style={{ padding: 0 }}>
					<ContentCard 
					style={{
						marginTop: 20,
						backgroundColor: '#0F2748',
						color: '#ffffff',
						borderRadius: 20,
						boxShadow: '0px 0px 10px rgba(255, 255, 255, 0.9)',
						opacity: '80%'
					}}>
						<ContentCardHeader
							style={{
								marginTop: 16,
								marginBottom: 16
							}}>
							<label>{this.props.incubacaoPlanejamentoFormTitulo}</label>

							{!this.props.modoAdm &&
							<TextoInput chave='incubacaoPlanejamentoFormTitulo' />}
						</ContentCardHeader>
						<Form event={this.props.handleSubmit}>
							<ContentCardBody>
								<Row>

									<Field
										name='situacao'
										component={LabelAndTextarea}
										label='Descreva brevemente a situação atual do seu negocio: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />

									<Field
										name='proposta_valor'
										component={LabelAndTextarea}
										label='Proposta de Valor: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />

									<Field
										name='desafios'
										component={LabelAndTextarea}
										label='Principais desafios enfrentados atualmente: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
										
									<Field
										name='forca_interna'
										component={LabelAndTextarea}
										label='Forças Internas: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
										
									<Field
										name='fraqueza_interna'
										component={LabelAndTextarea}
										label='Fraquezas Internas: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
										
									<Field
										name='oportunidade_externa'
										component={LabelAndTextarea}
										label='Oportunidades Externas: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
										
									<Field
										name='ameaca_externa'
										component={LabelAndTextarea}
										label='Ameaças Externas: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
										
									<Field
										name='proposito'
										component={LabelAndTextarea}
										label='Propósito: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
										
									<Field
										name='missao'
										component={LabelAndTextarea}
										label='Missão: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
										
									<Field
										name='visao_futuro'
										component={LabelAndTextarea}
										label='Visão: Onde quer chegar ao final de 36 meses: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
										
									<Field
										name='valores'
										component={LabelAndTextarea}
										label='Valores essencíais: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
										
									<Field
										name='publico_alvo'
										component={LabelAndTextarea}
										label='Valores essencíais: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
										
									<Field
										name='concorrentes'
										component={LabelAndTextarea}
										label='Principais concorrentes: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
										
									<Field
										name='tendencias_mercado'
										component={LabelAndTextarea}
										label='Tendências de mercado relevante : *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
										
									<Field
										name='diferenciais'
										component={LabelAndTextarea}
										label='Diferenciais em relação aos concorrentes: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
										
									<Field
										name='meta1_produto'
										component={LabelAndTextarea}
										label='Meta 01 Produto ou serviço: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
										
									<Field
										name='meta2_produto'
										component={LabelAndTextarea}
										label='Meta 02 Produto ou Serviço: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
										
									<Field
										name='meta1_venda'
										component={LabelAndTextarea}
										label='Meta 01 Vendas: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
										
									<Field
										name='meta2_venda'
										component={LabelAndTextarea}
										label='Meta 02 Vendas: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
										
									<Field
										name='meta1_marketing'
										component={LabelAndTextarea}
										label='Meta 01 Marketing: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
										
									<Field
										name='meta2_marketing'
										component={LabelAndTextarea}
										label='Meta 02 Marketing: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
										
									<Field
										name='meta1_financa'
										component={LabelAndTextarea}
										label='Meta 01 Finanças: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
										
									<Field
										name='meta2_financa'
										component={LabelAndTextarea}
										label='Meta 02 Finanças: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
										
									<Field
										name='meta1_inovacao'
										component={LabelAndTextarea}
										label='Meta 01 Inovação: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
										
									<Field
										name='meta2_inovacao'
										component={LabelAndTextarea}
										label='Meta 02 Inovação: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
										
									<Field
										name='meta1_pessoas'
										component={LabelAndTextarea}
										label='Meta 01 Desenvolvimento pessoal e equipe: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
										
									<Field
										name='meta2_pessoas'
										component={LabelAndTextarea}
										label='Meta 02 Desenvolvimento pessoal e equipe: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
																			
									{!this.props.excluir &&
									<Grid cols='12 12 12 12'
										style={{
											marginBottom: 12
										}}>

										<p>Anexo de planejamento já feito por terceiros:</p>

										{(this.props.formularioValues.anexos || []).map(arquivo => (
											<div style={{ display: 'flex', flexDirection: 'column', padding: 10 }}>
												<span class="btn btn-outline-primary fileinput-button dz-clickable">
													<img src={pdfAdicionado} style={{ height: 30 }} />
												</span>
												<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingRight: 2, marginTop: 4 }}>
													<button
														type='button'
														class='btn btn-flat btn-primary'
														style={{ width: '48%' }}
														disabled={arquivo.arquivo_base64 ? true : false}
														onClick={() => {
															window.open(`${consts.URL}/${arquivo.arquivo}`, '_blank');
														}}>
														<i class='fas fa-download'></i>
													</button>
													<button
														type='button'
														class='btn btn-flat btn-danger'
														style={{ width: '48%' }}
														disabled={readOnly}
														onClick={() => {
															this.props.initForm({
																...this.props.formularioValues,
																anexos: this.props.formularioValues.anexos.filter(item => item != arquivo)
															});
														}}>
														<i class='fas fa-trash-alt'></i>
													</button>
												</div>
											</div>
										))}
										
										<ClipboardImageHandler
											label='Use Ctrl+V para colar ou arraste e solte anexos aqui.'
											msgErro='Selecione apenas (.PDF)'
											types={[
												'application/pdf'
											]}
											onChange={result => {

												let lista = (this.props.formularioValues.anexos || []).map(item => item);
												lista.push({
													arquivo_base64: result
												});
												this.props.initForm({
													...this.props.formularioValues,
													anexos: lista
												});
											}} />
									</Grid>}
									
										
								</Row>

								<Row alignCenter>
									{!this.props.visualizacao &&
									<Grid cols='8 8 8 8'>
										{this.props.excluir ? (
											<Button
												text='Excluir'
												submit type={'danger'}
												icon={'fa fa-trash'} />
										) : (
										<Button
											text='Salvar'
											submit
											type={'success'}
											icon={'fa fa-check'} />
										)}
									</Grid>}
									{!this.props.modoAdm ? (
										<Grid cols='4 4 4 4'>
											<Button
												text='Voltar'
												type={'success'}
												icon={'fa fa-chevron-left'}
												event={() => window.confirm('Deseja realmente sair dessa tela?') ? this.props.setModoTela('lista') : null} />
										</Grid>
									) : (
										<Grid cols='4 4 4 4'>
											<Button
												text='Voltar'
												type={'success'}
												icon={'fa fa-chevron-left'}
												event={() => this.props.setModoTelaIncubacao('trilha')} />
										</Grid>
									)}
								</Row>
							</ContentCardBody>
						</Form>
					</ContentCard>
				</Grid>
			</Row>
		);
    }


}

IncubacaoPlanejamentoForm = reduxForm({form: 'incubacaoPlanejamentoForm', destroyOnUnmount: false})(IncubacaoPlanejamentoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('incubacaoPlanejamentoForm')(state),
	registro: state.incubacaoPlanejamento.registro,
	lista: state.incubacaoPlanejamento.lista,
	incubacaoPlanejamentoFormTitulo: state.texto.lista.filter(item => item.chave == 'incubacaoPlanejamentoFormTitulo').map(item => item.valor)[0]
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, 
	setModoTelaIncubacao
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(IncubacaoPlanejamentoForm);
